import * as React from 'react';
import { Link } from 'gatsby';

import { isNotSSR } from '@utils';

import { Index } from '../navigation-accordion';

import { firstLinksRowMobile, bikePortalsGroup, nurseryPortalsGroup } from './helpers';
import {
	ScMobileFooterGroups,
	ScMobileFooterInfo,
	ScMobileFooterText,
	ScMobileFooterTitle,
	ScMobileFooterWrapper,
} from './styled';

export const MobileFooter = ({ openModal }: { openModal: (modalType: string) => void }) => {
	return (
		<ScMobileFooterWrapper>
			<ScMobileFooterGroups>
				{firstLinksRowMobile.map((item) => (
					<Index item={item} key={item.title} openModal={openModal} />
				))}
				<Index item={{ title: 'Bike login', group: bikePortalsGroup }} />
				<Index item={{ title: 'Nursery login', group: nurseryPortalsGroup }} />
				<Link to="/faqs/">
					<ScMobileFooterTitle>FAQs</ScMobileFooterTitle>
				</Link>
				<ScMobileFooterTitle
					className="clickable-footer-link"
					onClick={() => {
						isNotSSR && window.open('https://www.linkedin.com/company/gogetabenefits/home/');
					}}
				>
					Linkedin
				</ScMobileFooterTitle>
			</ScMobileFooterGroups>
			<ScMobileFooterInfo>
				<ScMobileFooterText className="info">
					© 2026 Velomatch Limited t/a gogeta. Velomatch Limited t/a gogeta is a registered company
					in England and Wales as Velomatch Limited (No. 13403344). Our registered address is
					Birchin Court, 20 Birchin Lane, London EC3V 9DU. We are authorised and regulated by the
					Financial Conduct Authority under registration number 994240.
				</ScMobileFooterText>
				<ScMobileFooterText className="right">
					<Link to={'/cookie-policy/'}>
						<p>Cookies</p>
					</Link>
					<Link to={'/privacy-policy/'}>
						<p>Privacy Policy</p>
					</Link>
					<Link to={'/terms-and-conditions/'}>
						<p>Terms & Conditions</p>
					</Link>
				</ScMobileFooterText>
			</ScMobileFooterInfo>
		</ScMobileFooterWrapper>
	);
};
